module.exports = __webpack_public_path__ + "static/media/complexPic17.e7dca287.png";